import { httpClient } from '@/services/http/httpClient'

type Params = {
  ideaId: string
  kanbanStepId: string
  evaluators: string[]
  replicateEvaluators?: boolean
}

export async function assignCriteriaEvaluators({
  ideaId,
  kanbanStepId,
  evaluators,
  replicateEvaluators = false,
}: Params) {
  await httpClient.post(
    `/ideas/evaluations/criteria/${kanbanStepId}/evaluators`,
    {
      evaluatorIds: evaluators,
      ideaId,
      replicateEvaluators,
    },
  )
}
